/**
 * Mappe un produit du frontend vers le format Supabase (snake_case)
 */
export const mapProductToDb = (p) => {
  const mapped = {
    label: p.label || '',
    price: Number(p.price) || 0,
    purchase_price: Number(p.purchasePrice) || 0,
    margin: Number(p.margin) || 1.3,
    brand: p.brand || '',
    category: p.category || '',
    ref: p.ref || '',
    summary: p.summary || '',
    images: Array.isArray(p.images) ? p.images : [],
    video_url: p.videoUrl || '',
    stock: parseInt(p.stock) || 0,
    warranty: p.warranty || '',
    description: p.description || '',
    weight: Number(p.weight) || 0,
    height: Number(p.height) || 0,
    length: Number(p.length) || 0,
    width: Number(p.width) || 0,
    volume: Number(p.volume) || 0,
    is_matrix: !!p.isMatrix,
    options: Array.isArray(p.options) ? p.options : [],
    stock_map: (p.stockMap && typeof p.stockMap === 'object') ? p.stockMap : {},
    is_flash_sale: !!p.isFlashSale,
    flash_sale_discount: Number(p.flashSaleDiscount) || 0,
    flash_sale_start_date: p.flashSaleStartDate || null,
    flash_sale_end_date: p.flashSaleEndDate || null,
    on_order: !!p.onOrder,
    manuals: Array.isArray(p.manuals) ? p.manuals : [],
    plans: Array.isArray(p.plans) ? p.plans : [],
    datasheets: Array.isArray(p.datasheets) ? p.datasheets : []
  };

  // Note: Les colonnes suivantes n'existent pas encore dans la table 'products' de Supabase.
  // Pour les activer, vous devez les ajouter via le tableau de bord Supabase (type jsonb ou boolean).
  /*
  if (p.suppliers) mapped.suppliers = p.suppliers;
  if (p.variants) mapped.variants = p.variants;
  if (p.manuals) mapped.manuals = p.manuals;
  if (p.plans) mapped.plans = p.plans;
  if (p.datasheets) mapped.datasheets = p.datasheets;
  if (p.warrantyExtension) mapped.warranty_extension = p.warrantyExtension;
  if (p.thresholds) mapped.thresholds = p.thresholds;
  if (p.isEndOfSeries !== undefined) mapped.is_end_of_series = p.isEndOfSeries;
  if (p.reminderEligible !== undefined) mapped.reminder_eligible = p.reminderEligible;
  */

  return mapped;
};

/**
 * Mappe un produit de Supabase vers le format frontend (camelCase)
 */
export const mapProductFromDb = (p) => ({
  id: p.id,
  label: p.label,
  price: p.price,
  purchasePrice: p.purchase_price,
  margin: p.margin,
  brand: p.brand,
  category: p.category,
  ref: p.ref,
  summary: p.summary,
  images: p.images,
  videoUrl: p.video_url,
  stock: p.stock,
  warranty: p.warranty,
  description: p.description,
  weight: p.weight,
  height: p.height,
  length: p.length,
  width: p.width,
  volume: p.volume,
  isMatrix: p.is_matrix,
  options: p.options,
  stockMap: p.stock_map,
  variants: p.variants || [],
  isFlashSale: p.is_flash_sale,
  flashSaleDiscount: p.flash_sale_discount,
  flashSaleStartDate: p.flash_sale_start_date,
  flashSaleEndDate: p.flash_sale_end_date,
  onOrder: p.on_order,
  suppliers: p.suppliers || [],
  manuals: p.manuals || [],
  plans: p.plans || [],
  datasheets: p.datasheets || [],
  createdAt: p.created_at
});
